// Though Lightning use FontFace API, but it does not support
// the font-weight descriptor, hence, we will have two font-family here
export const UniNeueBold = 'UniNeueBold'
export const UniNeueBook = 'UniNeueBook'
export const UniNeueHeavy = 'UniNeueHeavy'
export const UniNeueLight = 'UniNeueLight'
export const UniNeueRegular = 'UniNeueRegular'
